
export const filterTaskLabels = (label) => !label.category || label.category.allowOnTasks;
export const filterProjectLabels = (label) => !label.category || label.category.allowOnProjects;
export const filterPeopleLabels = (label) => !label.category || label.category.allowOnPeople;

export const filterTaskLabelEdges = (edge) => filterTaskLabels(edge.node);
export const filterProjectLabelEdges = (edge) => filterProjectLabels(edge.node);
export const filterPeopleLabelEdges = (edge) => filterPeopleLabels(edge.node);